/**
 * CatchBoundary error UI for `/sector/$sectorId` (plan §1.4 · error §6).
 *
 * Discriminates InvalidSectorParamError from render-time crashes so a matrix
 * exception is never reported as "unknown sector".
 */
import { EmptyState } from '@/components/primitives/empty-state';

import { isInvalidSectorParamError } from './invalid-sector-param-error';

import type { JSX } from 'react';

export function SectorRouteError({ error }: { readonly error: unknown }): JSX.Element {
  if (isInvalidSectorParamError(error)) {
    return (
      <EmptyState title="Sector not found" description="Invalid or unknown sector in the URL." />
    );
  }
  return (
    <EmptyState
      title="Something went wrong"
      description="This screen could not be displayed. Reload the page to try again."
    />
  );
}
